"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function transport(state) {
    return state;
}
exports.transport = transport;
function totalPrice(state) {
    return state.totalPrice;
}
exports.totalPrice = totalPrice;
function valid(state) {
    return transportations(state).length > 0;
}
exports.valid = valid;
function validForLoad(state) {
    if (!validDirectionConfig(state.departure, state.departureConfig) ||
        !validDirectionConfig(state.arrival, state.arrivalConfig)) {
        return false;
    }
    return true;
}
exports.validForLoad = validForLoad;
function transportations(state) {
    return state.transportations;
}
exports.transportations = transportations;
function checkinTime(state) {
    return state.checkinTime;
}
exports.checkinTime = checkinTime;
function selectedClass(state) {
    return state.selectedClass;
}
exports.selectedClass = selectedClass;
function selectedTariffType(state) {
    return state.selectedTariffType;
}
exports.selectedTariffType = selectedTariffType;
function selectedCode(state) {
    return state.code;
}
exports.selectedCode = selectedCode;
function loadTransportParams(state) {
    var direction = 'RT';
    if (!state.arrival && state.departure)
        direction = 'O';
    if (state.arrival && !state.departure)
        direction = 'R';
    var params;
    params.direction = direction;
    params.transClass = state.selectedClass;
    return params;
}
exports.loadTransportParams = loadTransportParams;
// export everything compliant to the vuex specification for getters
exports.default = {
    transport: transport,
    totalPrice: totalPrice,
    valid: valid,
    validForLoad: validForLoad,
    transportations: transportations,
    selectedClass: selectedClass,
    selectedTariffType: selectedTariffType,
    selectedCode: selectedCode,
    loadTransportParams: loadTransportParams
};
// helper functions
function validDirectionConfig(active, config) {
    return active ? validConfig(config) : true;
}
function validConfig(config) {
    if (config.category === undefined) {
        return false;
    }
    return true;
}
//# sourceMappingURL=getters.js.map